<template>
  <div class="discount_coupon">
    <div
      style="
        height: constant(safe-area-inset-top);
        height: env(safe-area-inset-top);
        width: 100%;
        background-color: #fff;
        position: fixed;
        top: 0;
      "
    ></div>
    <div
      class="nav"
      :class="isandroid"
      style="
        background-color: #fff;
        position: fixed;
        width: 100%;
        margin: 0;
        top: constant(safe-area-inset-top);
        top: env(safe-area-inset-top);
        box-shadow: 0px 2px 4px 0px rgba(199, 195, 195, 0.2);
      "
    >
      <div class="rule">
        <img
          class="back"
          src="../../asset/img/icon-arr-left@2x.png"
          alt=""
          @click="goBack"
        />
        <span style="font-weight: 500">优惠券</span>
      </div>
    </div>
    <ul v-if="showList">
      <li v-for="(item, index) in list" :key="index">
        <div class="block">
          <div class="coupon_l">
            <div v-if="item.secondDiscountType == 1" class="discount_detail">
              <span class="num">{{ twoDecimal(item.discountAmount) }}</span>
              <span class="until">元</span>
            </div>
            <div v-if="item.secondDiscountType == 3" class="discount_detail">
              <span class="num">{{ item.discountRate | toRateNum }}</span>
              <span class="until">折</span>
            </div>
          </div>
          <div class="coupon_r">
            <div class="name">{{ item.cardName }}</div>
            <div class="date">{{ item.validityEnd }}</div>
            <div class="bottom">
              <!-- useExplain -->
              <div class="l" @click="handleRule(item, index)">
                <span class="useRule">使用规则</span>
                <img
                  v-if="item.flag"
                  src="../../asset/img/icon_up.png"
                  alt=""
                />
                <img v-else src="../../asset/img/icon_down.png" alt="" />
              </div>
              <a href="javascript:;" @click="handleUseCoupon(item)">去使用</a>
            </div>
          </div>
        </div>
        <div v-if="item.flag" class="tips">
          <div class="hint">提示:</div>
          <div class="content">{{ item.useExplain }}</div>
        </div>
      </li>
    </ul>
    <emptyBlock v-else txt="暂无更多优惠券"></emptyBlock>
  </div>
</template>
<script>
import { queryDiscount } from "../../helper/api/service-renewal";
import { SUCCESS_CODE } from "../../utils/config";
import { mapState } from "vuex";
import emptyBlock from "../../components/Empty";
export default {
  components: { emptyBlock },
  data() {
    return {
      headers: {},
      list: [],
      isandroid: "",
      flag: false,
      useExplain: "",
      showList: true
    };
  },
  created() {
    // 机型导航兼容
    if (window.publicMethods.appIsAndroidOrIOS() === "android") {
      this.isandroid = "aznav";
    } else {
      this.isandroid = "";
    }
    this.$bridge.call("Controller.refreshNav", {
      right: [],
      fullScreen: true,
      hiddenNav: true
    });
  },
  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapState({
      orderInfo: state => state.newServiceRenewal.orderInfo
    }),
    twoDecimal() {
      return function(val) {
        try {
          return (val / 100).toFixed(0);
        } catch (err) {
          return "--";
        }
      };
    }
  },
  // eslint-disable-next-line vue/order-in-components
  filters: {
    toRateNum(num) {
      let rate = typeof num === "number" ? num : Number(num);
      rate = (rate / 100) * 10;
      return rate;
    }
  },
  mounted() {
    const serviceRenewalInfo = this.$bridge.call("Storage.serviceRenewalInfo");
    if (!serviceRenewalInfo) {
      this.$toast("获取APP信息失败~~");
      return;
    }
    const { accessToken, brand, terminal, rs, enterpriseId } =
      serviceRenewalInfo || {};
    const headers = {
      brand,
      terminal,
      accessToken,
      rs,
      enterpriseId
    };
    this.headers = headers;
    this.queryCoupon();
  },
  methods: {
    handleRule(item, index) {
      this.list = this.list.map((item, idx) => {
        if (index === idx) {
          return {
            ...item,
            flag: !item.flag
          };
        }
        return {
          ...item,
          flag: false
        };
      });
    },
    // 返回
    goBack() {
      this.$router.replace({
        path: "/new-service-renewal/backlog?sourceType=coupon"
      });
    },
    // 使用优惠券
    handleUseCoupon(row) {
      console.log(row);
      this.$store.commit("setCouponInfo", {
        discountAmount: Number(row.discountAmount),
        childId: row.childId,
        secondDiscountType: row.secondDiscountType,
        discountRate: Number(row.discountRate)
      });
      this.$router.replace({
        path: "/new-service-renewal/backlog?sourceType=coupon"
      });
    },
    // 查询优惠券
    queryCoupon() {
      const {
        orderItemList: [{ productSkuId, productPrice, productCategoryId }]
      } = this.orderInfo || {};
      const params = {
        couponStatusList: [2], // 2: 未使用
        skuList: [
          {
            goodsNum: 1,
            skuId: productSkuId,
            goodsPrice: productPrice,
            categoryId: productCategoryId
          }
        ]
      };
      queryDiscount(params, this.headers).then(res => {
        const data = res.data || {};
        if (data.code === SUCCESS_CODE) {
          this.list = ((data.data || {}).couponList || []).map(v => {
            v.flag = false; // 箭头标识
            return v;
          });
          this.showList = !!this.list.length;
        } else {
          this.showList = false;
          this.$toast(data.description);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../asset/scss/mixin.scss";
.discount_coupon {
  background: #f6f6f6;
  min-height: 100vh;
  .aznav {
    padding-top: pxTorem(20);
  }
  .rule {
    display: flex;
    align-items: center;
    padding: pxTorem(10);
    padding-bottom: pxTorem(10);
    position: relative;
    span {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      z-index: -1;
    }
    .back {
      width: pcTorem(22);
      height: pxTorem(22);
    }
  }
  ul {
    padding: pxTorem(20) pxTorem(15);
    padding-top: pxTorem(80);
    .tips {
      margin-top: pxTorem(-2);
      background: #fff;
      padding: pxTorem(16) pxTorem(12);
      .hint {
        font-size: pxTorem(14);
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333335;
      }
      .content {
        color: #656566;
        font-size: pxTorem(14);
        line-height: pxTorem(28);
      }
    }
  }
  .block {
    display: flex;
    justify-content: space-between;
    margin-bottom: pxTorem(10);
    margin-top: pxTorem(20);
    .coupon_l {
      width: pxTorem(93);
      background: rgba(215, 0, 15, 0.05);
      display: flex;
      justify-content: center;
      align-items: center;
      .discount_detail {
        height: pxTorem(48);
        line-height: pxTorem(48);
        .num {
          color: #d7000f;
          font-size: pxTorem(30);
        }
        .until {
          color: #d7000f;
        }
      }
    }
    .coupon_r {
      flex: 1;
      box-sizing: border-box;
      padding: pxTorem(20) pxTorem(15) pxTorem(20) pxTorem(8);
      background: #fff;
      .name {
        font-size: pxTorem(15);
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333335;
        line-height: pxTorem(22);
      }
      .date {
        margin-top: pxTorem(4);
        height: pxTorem(15);
        font-size: pxTorem(12);
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #656566;
        line-height: pxTorem(15);
      }
      .bottom {
        margin-top: pxTorem(22);
        display: flex;
        justify-content: space-between;
        align-items: center;
        .l {
          display: flex;
          align-items: center;
          .useRule {
            height: pxTorem(15);
            font-size: pxTorem(12);
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #656566;
            line-height: pxTorem(15);
          }
          img {
            height: pxTorem(15);
          }
        }

        a {
          text-align: center;
          width: pxTorem(60);
          height: pxTorem(22);
          line-height: pxTorem(22);
          background: #d7000f;
          border-radius: pxTorem(30);
          color: #fff;
          font-size: pxTorem(12);
          font-family: PingFangSC-Regular, PingFang SC;
        }
      }
    }
  }
}
</style>
